import styled from 'styled-components';


export const ModalContainer = styled.div`
  

`;